import { KeyboardArrowDown } from "@mui/icons-material";
import { Pagination, MenuItem, Select, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const PaginationWrapper = styled(Box)(
  ({ theme }) => `
        display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: auto;
  padding: 0 24px;
  margin-top: 24px;

       
`
);
const PaginationSelect = styled(Box)(
  ({ theme }) => `
 
  display: flex !important;
  align-items: center !important;
  & .MuiTypography-root {
    color: #575859 !important;
    font-weight: ${theme.text.fontWeights.regular} !important;
    text-align: left !important;
    font-size: ${theme.text.fontSizes.md} !important;
    margin-right:4px
  }
  & .MuiSelect-outlined{
  padding:8px !important;
  }
   & .MuiOutlinedInput-input{
 min-width:36px !important;
  display: flex !important;
  align-items: center !important;
  gap: 4px !important;
  margin-top: 4px !important;

  & .MuiSelect-icon{
  right:-4px !important;
  }

  } 
 & .MuiInputBase-root{
  border-radius: 10px !important;
  height:32px !important;
 
 }
`
);
const PaginationBox = styled(Box)(
  ({ theme }) => `
 
       
`
);

interface CustomTablePaginationPropTypes {
  pagination: any;
  setPagination: Function;
  totalItems: any;
}

const PaginationComponent: React.FC<CustomTablePaginationPropTypes> = ({
  pagination,
  setPagination,
  totalItems,
}) => {
  const rowsPerPageOptions = [10, 25, 50, 75, 100];

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    const rowsPerPage = event.target.value as number;
    setPagination((previousValues: any) => {
      return {
        ...previousValues,
        skip: 0,
        take: rowsPerPage,
      };
    });
  };

  return (
    <PaginationWrapper>
      <PaginationSelect>
        <Select
          value={pagination.take || rowsPerPageOptions[0]}
          onChange={(event: any) => handleChangeRowsPerPage(event)}
          variant="outlined"
          IconComponent={KeyboardArrowDown}
          MenuProps={{
            PaperProps: {
              className: "customMenuPaper",
            },
          }}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </PaginationSelect>

      <PaginationBox>
        <Pagination
          count={totalItems && Math.ceil(totalItems / pagination.take)}
          page={pagination.skip + 1}
          variant="outlined"
          shape="rounded"
          onChange={(_, newPage) => {
            setPagination((previousValues: any) => {
              return {
                ...previousValues,
                skip: newPage - 1,
              };
            });
          }}
        />
      </PaginationBox>
    </PaginationWrapper>
  );
};

export default PaginationComponent;
